import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EcgHistoryListResponse } from '~/models/common';
import { getEcgHistoryList } from '~/services/ecgHistoryService';
import { thunkAction } from '~/utils/utils';

type EcgHistoryState = {
  ecgHistory: EcgHistoryListResponse | null;
  error: unknown;
  loading: boolean;
};

const initialState: EcgHistoryState = {
  ecgHistory: null,
  error: {},
  loading: false,
};

export const fetchEcgHistoryList = createAsyncThunk(
  'ecgHistory/list',
  thunkAction(
    async (payload: {
      day: number;
      month: number;
      year: number;
      userId: string;
      isLatest?: boolean;
    }) => {
      const res = await getEcgHistoryList(payload);
      return res?.data?.getEcgHistoryList as EcgHistoryListResponse;
    },
  ),
);

const ecgHistorySlice = createSlice({
  name: 'ecgHistory',
  initialState,
  reducers: {
    clearEcgHistory(state) {
      state.ecgHistory = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchEcgHistoryList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEcgHistoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.ecgHistory = action.payload ?? null;
    });
    builder.addCase(fetchEcgHistoryList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ?? action.error;
    });
  },
});

export const { clearEcgHistory } = ecgHistorySlice.actions;
export default ecgHistorySlice.reducer;
